import React, { useState, useEffect } from 'react';
import GooglePayCS from '../GooglePayCS';
import ApplePayCS from '../ApplePayCS';
import GPay from '../../checkout/GooglePay';
import APay from '../../checkout/ApplePay';
import '../../checkout/GpayApayContainer/style.css';

export default function CsWalletContainer({ data, encryptData, base64Data, setError, setMessage, setFailedMessage, setLoading }) {
  const [gpayComponent, setGpayComponent] = useState(null);
  const [apayComponent, setApayComponent] = useState(null);

  useEffect(() => {
    if (data.gpay_enabled) {
      const gpayEntity = data?.entity?.GPAY;
      let GpayComponent = GPay;
      if (gpayEntity === 'EARTH') {
        GpayComponent = GooglePayCS;
      } else if (gpayEntity === 'CHECKOUT' || !gpayEntity) {
        GpayComponent = GPay;
      }
      setGpayComponent(
        <GpayComponent
          encryptData={encryptData}
          base64Data={base64Data}
          data={data}
          setError={setError}
          setMessage={setMessage}
          setFailedMessage={setFailedMessage}
          setLoading={setLoading}
        />
      );
    }

    if (data.apay_enabled) {
      const apayEntity = data?.entity?.APAY;
      const ApayComponent = apayEntity === 'EARTH' ? ApplePayCS : APay;
      setApayComponent(
        <ApayComponent
          encryptData={encryptData}
          base64Data={base64Data}
          decodedString={data}
          setError={setError}
          setMessage={setMessage}
          setFailedMessage={setFailedMessage}
          setLoading={setLoading}
        />
      );
    }
  }, [encryptData, base64Data, data, setError, setMessage, setFailedMessage, setLoading]);

  if (!data?.gpay_enabled && !data?.apay_enabled) return null;

  return (
    <>
      <div className='gpay-apay-button-container'>
        {gpayComponent}
        {apayComponent}
      </div>
      <div className='partition-container'>
        <span className='partition-text'>Or pay using your card</span>
      </div>
    </>
  );
}
